module.exports = __webpack_public_path__ + "static/1-015-4c5266a1909e7e609599781775fd50c1.png";